import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const SellerCatalogPage = withSuspense(lazy(() => import('./seller-catalog-search')));
export default SellerCatalogPage;
